/**
 * The letter of a banner column (M4S-5777 X12): the one home of the rule. A…Z for the first 26
 * lettered columns, then AA…AZ, BA…BZ, and so on, so a letter never degrades into ASCII
 * punctuation (`[`, `\`, …) or collides on a banner with more than 26 columns.
 *
 * Every place that names a column by letter reads this: the engine (`computeFromApi.ts`), the
 * Build rail's banner chips (`banner-names.ts`), Slide Creator's reading of an uploaded workbook
 * (`slide-creation/crosstab-parse.ts`) and the iOOH workbook parser's flat-format letters
 * (`iooh-crosstab-parser.ts`). `one-rule.guard.test.ts` fails on a second copy.
 *
 * Pure.
 */

const A = 65;

/**
 * The letter of column `index`, counting from 0 for the first lettered column: 0 → A, 25 → Z,
 * 26 → AA, 701 → ZZ, 702 → AAA. A negative or non-integer index has no letter ('').
 */
export function columnLetter(index: number): string {
    if (!Number.isInteger(index) || index < 0) return '';
    let n = index + 1;
    let out = '';
    while (n > 0) {
        const rem = (n - 1) % 26;
        out = String.fromCharCode(A + rem) + out;
        n = Math.floor((n - 1) / 26);
    }
    return out;
}

/** The 0-based index a column letter names (the inverse of `columnLetter`), or -1. */
export function columnIndexOfLetter(letter: string): number {
    if (!/^[A-Z]+$/.test(letter)) return -1;
    let n = 0;
    for (const ch of letter) n = n * 26 + (ch.charCodeAt(0) - A + 1);
    return n - 1;
}
